export const PAIRING_CODE_LENGTH = 6;

/**
 * Extracts a complete pairing code from pasted or generated text, ignoring
 * spaces, dashes and other separators (e.g. "123 456" → ["1","2","3","4","5","6"]).
 * Returns null when fewer than six digits are present.
 */
export function digitsFromPaste(text: string): string[] | null {
  const digits = (text || "").replace(/\D/g, "");
  return digits.length >= PAIRING_CODE_LENGTH
    ? digits.slice(0, PAIRING_CODE_LENGTH).split("")
    : null;
}
